<script setup lang="ts">
import type { ShortcutData } from '@/common/components/molecules/keyboardShortcutGuide/keyboardShortcutGuide.type';
import KeyboardShortcutItem from '@/common/components/molecules/keyboardShortcutGuide/KeyboardShortcutItem.vue';

interface Props {
  items?: ShortcutData[];
  suffixItems?: ShortcutData[];
}

const props = withDefaults(defineProps<Props>(), {
  items: () => [],
  suffixItems: () => [],
});
</script>

<template>
  <h-stack
    class="keyboard-shortcut-guide"
    align="center"
    justify="space-between"
  >
    <h-stack
      v-if="props.items.length"
      class="keyboard-shortcut-guide__prefix"
      :spacing="16"
      align="center"
    >
      <keyboard-shortcut-item
        v-for="(item, idx) in props.items"
        :key="`prefix-${idx}`"
        :data="item"
      />
    </h-stack>

    <h-stack
      v-if="props.suffixItems.length"
      class="keyboard-shortcut-guide__suffix"
      :spacing="6"
      align="center"
    >
      <keyboard-shortcut-item
        v-for="(item, idx) in props.suffixItems"
        :key="`suffix-${idx}`"
        :data="item"
      />
    </h-stack>
  </h-stack>
</template>

<style scoped lang="scss">
.keyboard-shortcut-guide {
  width: 100%;
  min-height: 18px;
}
.keyboard-shortcut-guide__suffix {
  flex-shrink: 0;
  margin-left: auto;
}
</style>
